import React, { useState } from 'react'

import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import CheckboxInput from '../../../../components/form/CheckboxInput'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import DateInput from '../../../../components/form/date/DateInput'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Picker from '../../../../components/form/Picker'
import { InfoIconTooltip } from '../../../../components/helpers/InfoIconTooltip'
import { COLORS } from '@btime/constants'
import { getFieldsConfigOptions } from '../sections/GeneralSection'
import { useTranslation } from 'react-i18next'

const CustomEntitySection = ({ disabled = false, isMultiSelect = false }) => {
  const { handleChangeIn } = useFormState()
  const { t } = useTranslation('export')
  const fieldsConfigOptions = getFieldsConfigOptions(t)
  const { entity, empty, includeReplies } = useForm()
  const [periodType, setPeriodType] = useState('insertedAt')
  if (empty || entity !== 'serviceOrder') return false

  return (
    <>
      {!isMultiSelect && (
        <>
          <Picker
            options={[
              { value: 'insertedAt', label: t('creationDate') },
              { value: 'scheduling', label: t('schedulingDate') }
            ]}
            onChange={(selected = 'insertedAt') => {
              setPeriodType(selected)
              handleChangeIn(['filter', 'periodType'], selected)
              if (selected === 'insertedAt') {
                handleChangeIn(['filter', 'scheduling'], undefined)
              } else {
                handleChangeIn(['filter', 'insertedAt'], undefined)
              }
            }}
            value={periodType}
          />
          <Separator weight={2} />
          {periodType === 'insertedAt' && (
            <FormItem label={t('period') + '*'} Input={DateInput} path={['filter', 'insertedAt']} useRange />
          )}

          {periodType === 'scheduling' && (
            <FormItem label={t('period') + '*'} Input={DateInput} path={['filter', 'scheduling']} useRange />
          )}
        </>
      )}
      <Separator weight={4} />
      <div style={{ display: 'flex', alignItems: 'center', color: COLORS.dark2 }}>
        <FormItem
          label={t('includeReplies')}
          ignoreLabel
          Input={CheckboxInput}
          field="includeReplies"
          disabled={disabled}
          afterChange={() => {
            handleChangeIn(['fieldsConfig'], fieldsConfigOptions[0])
          }}
        />
        <InfoIconTooltip style={{ marginLeft: '5px' }} text={t('includeRepliesTooltip')} />
      </div>

      {includeReplies && (
        <>
          <Separator weight={4} />
          <FormItem
            label={t('checklist') + '*'}
            Input={ChecklistSelect}
            path={['filter', 'checklistIds']}
            disabled={disabled}
          />
          <Separator weight={4} />
          <div style={{ display: 'flex', alignItems: 'center', color: COLORS.dark2 }}>
            <FormItem
              label={t('formatBlockQuestions')}
              ignoreLabel
              Input={CheckboxInput}
              field="includeBlockQuestions"
              disabled={disabled}
              afterChange={check => {
                if (check) {
                  handleChangeIn(['fieldsConfig'], fieldsConfigOptions[0])
                }
              }}
            />
            <InfoIconTooltip style={{ marginLeft: '5px' }} text={t('formatBlockQuestionsTooltip')} />
          </div>
        </>
      )}
      <Separator weight={4} />
    </>
  )
}

export default CustomEntitySection
